import React from "react";
import AttribuesThumnail from "../../../../../assets/images/attributes";

const EbitdaContent = ({ attributes }) => {
  let ebitda_year_one =
    attributes.ebitda_year_one != "none" && Object.keys(attributes).length > 0
      ? attributes.ebitda_year_one
      : 0;
  if (ebitda_year_one >= 1000000 || ebitda_year_one <= -1000000) {
    if (ebitda_year_one % 1000000 === 0) {
      ebitda_year_one = ebitda_year_one / 1000000 + "mm";
    } else {
      ebitda_year_one = parseFloat(ebitda_year_one / 1000000).toFixed(2) + "mm";
    }
  } else if (ebitda_year_one >= 100000 || ebitda_year_one <= -100000) {
    if (ebitda_year_one % 1000 === 0) {
      ebitda_year_one = ebitda_year_one / 1000 + "k";
    } else {
      ebitda_year_one = parseFloat(ebitda_year_one / 1000).toFixed(2) + "k";
    }
  } else if (ebitda_year_one >= 10000 || ebitda_year_one <= 10000) {
    if (ebitda_year_one % 1000 === 0) {
      ebitda_year_one = ebitda_year_one / 1000 + "k";
    } else {
      ebitda_year_one = parseFloat(ebitda_year_one / 1000).toFixed(2) + "k";
    }
  } else if (ebitda_year_one >= 1000 || ebitda_year_one <= 1000) {
    if (ebitda_year_one % 10000 === 0) {
      ebitda_year_one = ebitda_year_one / 10000 + "k";
    } else {
      ebitda_year_one = parseFloat(ebitda_year_one / 10000).toFixed(2) + "k";
    }
  }

  const formatValue = (val) => {
    let value = val;

    if (typeof val === "string") {
      value = value ? value.replaceAll(/[mmk]/g, "") : value;
    }

    return value;
  };

  const formatSuffix = (val) => {
    let value = "";

    if (typeof val === "string") {
      value = val.includes("mm") ? "mm" : val.includes("k") ? "k" : "";
    }

    return value;
  };
  const amount = formatValue(ebitda_year_one.toString().replaceAll("-", ""));

  return (
    <div className="stats">
      <img className="thumb" src={AttribuesThumnail.Ebidta} alt="" />
      <h4>
        EBITDA <i>({formatSuffix(ebitda_year_one)})</i>
      </h4>
      <h2>
        {amount == 0 ? (
          "-"
        ) : (
          <>
            {ebitda_year_one.toString().includes("-") && "-"}${amount}
          </>
        )}
      </h2>
    </div>
  );
};

export default EbitdaContent;
